var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item,index){return _c('el-button',{key:index,staticStyle:{"margin-top":"10px"},on:{"click":function($event){return _vm.$router.push(item.path)}}},[_vm._v(_vm._s(item.meta.title))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }